export { default } from './Drawer';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Drawer/index.js
// module id = 823
// module chunks = 2